import { UseQueryResult, useQuery } from "react-query";
import { Costumer } from "../model/costumer";
import { listCostumers } from "./list-costumers";

export const queryKeys = {
  listCostumers: () => "listCostumers"
};

export function useListCostumers(): UseQueryResult<Costumer[], Error> {
  return useQuery(queryKeys.listCostumers(), () => listCostumers(), {
    refetchOnWindowFocus: false,
    retry: 3
  });
}
